import { render, staticRenderFns } from "./OverlayLoad.vue?vue&type=template&id=f24cfc68&scoped=true&"
import script from "./OverlayLoad.vue?vue&type=script&lang=js&"
export * from "./OverlayLoad.vue?vue&type=script&lang=js&"
import style0 from "./OverlayLoad.vue?vue&type=style&index=0&id=f24cfc68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24cfc68",
  null
  
)

export default component.exports